import { render, staticRenderFns } from "./SortUpDown.vue?vue&type=template&id=10ff56a2&scoped=true"
import script from "./SortUpDown.vue?vue&type=script&lang=js"
export * from "./SortUpDown.vue?vue&type=script&lang=js"
import style0 from "./SortUpDown.vue?vue&type=style&index=0&id=10ff56a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ff56a2",
  null
  
)

export default component.exports